import lazyPage from '@monorepo/core/hoc/lazyPage'

export default () => ({
  path: '/about-us',
  component: lazyPage(() =>
    import('App/View/AboutUs').then(({ AboutUs }) => AboutUs)
  ),
  exact: true,
})
